import { setEdgeHeader } from "@pantheon-systems/wordpress-kit";
// import axios from "axios";
import { NextSeo } from "next-seo";
import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import Layout from "../components/layout";
import Link from "next/link";
// import { getLatestPosts } from '../lib/Posts';
import { BASE_API_URL, API_AUTHCODE, SITE_URL } from "../lib/constants";
import useRedirectHandler from "../components/utils/RedirectHandler";
import MoonLoader from "react-spinners/MoonLoader";
export default function Home() {
  const [banner, setBanner] = useState();
  const [loading, setLoading] = useState(true);
  const [postsData, setPostsData] = useState();
  const [categoriesData, setCategoriesData] = useState([]);
  const [eventCategories, setEventCategories] = useState([]);
  const [eventPosts, setEventPosts] = useState([]);
  const [reloadItem, setReloadItem] = useState(0);
  const [allImages, setAllImage] = useState([]);
  const [isAlreadyImages, setIsAlreadyImages] = useState([]);
  let [currentSlide, setCurrentSlide] = useState(0);
  let [translateVal, setTranslateVal] = useState(0);
  const [currentEventCat, setCurrentEventCat] = useState(0);
  const [metaData, setMetaData] = useState("");
  const [isAlreadyAdded, setAlreadyAdded] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [slideWrapperWidth, SetslideWrapperWidth] = useState(10000);
  const [slideItemWidth, SetslideItemWidth] = useState(0.0);
  const targetRef = useRef();
  const myRef = useRef();
  const [redirectHandle] = useRedirectHandler();
  // Redirect to another page
  const handleRedirect = (ele) => {
    redirectHandle(ele);
  };

  useEffect(() => {
    let ItemWidth =
      targetRef &&
      targetRef.current &&
      targetRef.current.offsetWidth &&
      parseFloat(targetRef.current.offsetWidth / 3 - 40).toFixed(1);
    let warpperWidth = "10000";
    if (postsData) {
      warpperWidth = (parseFloat(ItemWidth) + 40) * postsData.length;
    }
    SetslideWrapperWidth(warpperWidth);
    SetslideItemWidth(ItemWidth);
  }, [targetRef, postsData]);

  useEffect(() => {}, [reloadItem]);

  useEffect(async () => {
    let res = await fetch(
      BASE_API_URL + "wp/v2/pages?slug=home&acf_format=standard",
      {
        headers: {
          //  'Authorization' : API_AUTHCODE,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ).then((res) => {
      let jsonValid = true;
      Object.keys(res).forEach((key) => {
        if (response[key] == "") {
          valid = false;
        }
      });
      if (jsonValid) {
        return res.json();
      }
    });

    if (res) {
      setBanner(res[0]);
    }
  }, []);

  useEffect(() => {
    getPostsByCategories();
    getCategoryNames();
    getEventCategories();
    getEventPosts(0);

    let scripts = ["../../js/homeScript.js"];
    if (isAlreadyAdded != 1) {
      scripts &&
        scripts.map((ele, ind) => {
          const script = document.createElement("script");
          script.src = ele;
          script.async = true;
          script.crossOrigin = "anonymous";
          document.body.appendChild(script);
          if (ind == scripts.length - 1) {
            setAlreadyAdded(1);
            setReloadItem(!reloadItem);
          }
        });
    }

    setLoading(false);
  }, [banner]);

  const getEventCategories = async () => {
    let res = await fetch(BASE_API_URL + "wp/v2/eventcategory", {
      headers: {
        //  'Authorization' : API_AUTHCODE,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((res) => {
      let jsonValid = true;
      Object.keys(res).forEach((key) => {
        if (response[key] == "") {
          valid = false;
        }
      });
      if (jsonValid) {
        return res.json();
      }
    });

    if (res) {
      setEventCategories(res);
    }
  };
  const getEventPosts = async (catId) => {
    setCurrentEventCat(catId);
    setReloadItem(!reloadItem);
    let categories = banner?.acf?.upcoming_event_event_categories;

    if (categories && categories.length > 0) {
      let categoriesIds = "";
      categories.map((cat, ind) => {
        if (ind == 0) {
          categoriesIds = cat;
        } else {
          categoriesIds = categoriesIds + ", " + cat;
        }
      });

      if (categoriesIds) {
        let res = await fetch(
          BASE_API_URL +
            "wp/v2/event?per_page=100&order=asc&order_by=event_date&status=publish&categories=" +
            categoriesIds,
          {
            headers: {
              //  'Authorization' : API_AUTHCODE,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        ).then((res) => {
          let jsonValid = true;
          Object.keys(res).forEach((key) => {
            if (response[key] == "") {
              valid = false;
            }
          });
          if (jsonValid) {
            return res.json();
          }
        });

        if (res) {
          let i = 1;
          setEventPosts([]);
          setReloadItem(!reloadItem);

          var sortedbyValueJSONArray = sortByValue(res);
          sortedbyValueJSONArray &&
            sortedbyValueJSONArray.length > 0 &&
            sortedbyValueJSONArray.map((pdata, index) => {
              let eventDate = pdata[1].acf.event_date;
              var dt = new Date();

              let toYear = dt.getFullYear();
              let toMonth =
                dt.getMonth() < 10
                  ? "0" + (dt.getMonth() + 1)
                  : dt.getMonth() + 1;
              let toDate =
                dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
              let currentDate = toYear + "" + toMonth + "" + toDate;

              if (catId) {
                if (
                  eventDate >= currentDate &&
                  i <= banner?.acf?.upcoming_event_no_of_events &&
                  catId == pdata[1].eventcategory[0]
                ) {
                  let cont = pdata[1]?.content?.rendered;
                  pdata[1].content = cont;

                  let excerpt = pdata[1]?.excerpt?.rendered;
                  pdata[1].excerpt = excerpt;

                  let guid = pdata[1]?.guid?.rendered;
                  pdata[1].guid = guid;

                  let title = pdata[1]?.title?.rendered;
                  pdata[1].title = title;

                  setEventPosts((arr) => [...arr, pdata[1]]);
                  setReloadItem(!reloadItem);
                  i = i + 1;
                }
              } else {
                if (
                  eventDate >= currentDate &&
                  i <= banner?.acf?.upcoming_event_no_of_events
                ) {
                  let cont = pdata[1]?.content?.rendered;
                  pdata[1].content = cont;

                  let excerpt = pdata[1]?.excerpt?.rendered;
                  pdata[1].excerpt = excerpt;

                  let guid = pdata[1]?.guid?.rendered;
                  pdata[1].guid = guid;

                  let title = pdata[1]?.title?.rendered;
                  pdata[1].title = title;

                  setEventPosts((arr) => [...arr, pdata[1]]);
                  setReloadItem(!reloadItem);
                  i = i + 1;
                }
              }
            });
        }
      } else {
        return "No Category selected ! Please choose any one category from admin.";
      }
    } else {
      return "No Category selected ! Please choose any one category from admin.";
    }
  };

  const sortByValue = (jsObj) => {
    var sortedArray = [];
    for (var i in jsObj) {
      // Push each JSON Object entry in array by [value, key]
      sortedArray.push([jsObj[i].acf.event_date, jsObj[i]]);
    }
    return sortedArray.sort();
  };
  const getPostsByCategories = async () => {
    let categories = banner?.acf?.stay_informed_post_category;
    if (categories && categories.length > 0) {
      let categoriesIds = "";
      categories.map((cat, ind) => {
        if (ind == 0) {
          categoriesIds = cat;
        } else {
          categoriesIds = categoriesIds + ", " + cat;
        }
      });
      if (categoriesIds) {
        let res = await fetch(
          BASE_API_URL +
            "wp/v2/posts?per_page=6&order=desc&status=publish&acf_format=standard&categories=" +
            categoriesIds,
          {
            headers: {
              //  'Authorization' : API_AUTHCODE,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        ).then((res) => {
          let jsonValid = true;
          Object.keys(res).forEach((key) => {
            if (response[key] == "") {
              valid = false;
            }
          });
          if (jsonValid) {
            return res.json();
          }
        });

        if (res) {
          let allupdate = false;
          res &&
            res.length > 0 &&
            res.map((pdata, index) => {
              let cont = pdata?.content?.rendered;
              res[index].content = cont;

              let excerpt = pdata?.excerpt?.rendered;
              res[index].excerpt = excerpt;

              let guid = pdata?.guid?.rendered;
              res[index].guid = guid;

              let title = pdata?.title?.rendered;
              res[index].title = title;
              if (index == res.length - 1) {
                allupdate = true;
              }
            });
          if (allupdate) {
            setPostsData(res);
          }
        }
      } else {
        return "No Category selected ! Please choose any one category from admin.";
      }
    } else {
      return "No Category selected ! Please choose any one category from admin.";
    }
  };
  const getCategoryNames = async () => {
    let res = await fetch(BASE_API_URL + "wp/v2/categories", {
      headers: {
        //  'Authorization' : API_AUTHCODE,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((res) => {
      let jsonValid = true;
      Object.keys(res).forEach((key) => {
        if (response[key] == "") {
          valid = false;
        }
      });
      if (jsonValid) {
        return res.json();
      }
    });

    if (res) {
      setCategoriesData(res);
    }
  };

  const getCatnameById = (id) => {
    let result = categoriesData.filter((ele) => ele.id == id);
    if (result && result.length > 0) {
      return result[0].name;
    } else {
      return "";
    }
  };

  const getEventCats = (data) => {
    let catNames = "";
    data &&
      data.length > 0 &&
      data.map((cat, ind) => {
        let result = eventCategories.filter((ele) => ele.id == cat);
        if (result && result.length > 0) {
          catNames = catNames + " " + result[0].slug;
        } else {
          return "";
        }
      });
    return catNames;
  };
  const getCovertMonthFormat = (dat) => {
    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    let mon = dat.substring(4, 6);

    let dateFormat = months[mon - 1];

    return dateFormat;
  };

  const getCovertTimeFormat = (tim) => {
    let time = tim.substring(0, 2);
    let onlytime = tim.substring(0, 5);
    if (time >= 12) {
      return onlytime + " pm";
    } else {
      return onlytime + " am";
    }
  };

  const getImageUrl = (imageId) => {
    let isAlready = false;
    isAlreadyImages &&
      isAlreadyImages.length > 0 &&
      isAlreadyImages.map((item) => {
        if (item == imageId) {
          isAlready = true;
        }
      });
    if (!isAlready) {
      getMediaUrlById(imageId);
    }
    let srcurl = allImages && allImages.filter((item) => item.id == imageId);

    let url = srcurl && srcurl.length > 0 && srcurl[0] && srcurl[0].Url;
    return url;
  };
  const getMediaUrlById = async (id) => {
    let isAlready = false;
    isAlreadyImages &&
      isAlreadyImages.length > 0 &&
      isAlreadyImages.map((item) => {
        if (item == id) {
          isAlready = true;
        }
      });

    if (!isAlready) {
      if (id != null && id != undefined && id != "") {
        setIsAlreadyImages((arr) => [...arr, id]);
        await fetch(BASE_API_URL + "wp/v2/media/" + id, {
          headers: {
            //  'Authorization' : API_AUTHCODE,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }).then((res) => {
          if (res) {
            let pdata = res.data;
            let cont = pdata?.content?.rendered;
            pdata.content = cont;

            let excerpt = pdata?.excerpt?.rendered;
            pdata.excerpt = excerpt;

            let guid = pdata?.guid?.rendered;
            pdata.guid = guid;

            let title = pdata?.title?.rendered;
            pdata.title = title;

            let newImageArray = { id: id, Url: pdata.guid };

            setAllImage((arr) => [...arr, newImageArray]);
            setReloadItem(!reloadItem);
          }
        });
      }
    }
  };

  const getCovertDateFormat = (dat) => {
    let date = dat.substring(6);

    let dateFormat = date;

    return dateFormat;
  };
  function changeSlide(ele) {
    const outWidth = myRef.current.clientWidth;
    const exactWidth = outWidth + 40;
    if (ele == "prev") {
      if (currentSlide) {
        setCurrentSlide(currentSlide - 1);
        setTranslateVal(-(exactWidth * 3 * (currentSlide - 1)));
        setReloadItem(!reloadItem);
      } else {
        setCurrentSlide(0);
        setTranslateVal(0);
        setReloadItem(!reloadItem);
      }
    } else {
      let totalPages =
        postsData &&
        (postsData.length % 3 == 0
          ? postsData.length / 3
          : postsData.length / 3 + 1);
      if (totalPages == currentSlide + 1) {
        setCurrentSlide(0);
        setTranslateVal(-0);
        setReloadItem(!reloadItem);
      } else {
        setCurrentSlide(currentSlide + 1);
        setTranslateVal(-(exactWidth * 3 * (currentSlide + 1)));
        setReloadItem(!reloadItem);
      }
    }

    getPaginations(postsData && postsData.length);
  }
  const getFitSizeimage = (item1, item2) => {
    let item1Array = item1.split("/");
    let item1Length = item1Array.length;
    for (let i = 0; i < item1Length; i++) {
      if (i == item1Length - 1) {
        item1Array[i] = item2;
      }
    }

    let imgUrl = item1Array.join("/");
    return imgUrl;
  };
  const getPaginations = (len) => {
    let pagiHtml = "";
    let slidelen = len % 3 == 0 ? len / 3 : len / 3 + 1;
    for (let i = 0; i < slidelen; i++) {
      let classVal = "";
      if (i == currentSlide) {
        classVal = "active";
      }

      pagiHtml =
        pagiHtml +
        "<span onClick={changeSlide(" +
        i +
        ')} class="' +
        classVal +
        '">&nbsp;</span>';
    }
    return pagiHtml;
  };
  useEffect(() => {
    let yoastData = banner && banner?.yoast_head_json;
    setMetaData(yoastData);
    setReloadItem(!reloadItem);
  }, [banner]);
  const closeBar = () => {
    $(".description-area").hide();
  };

  const handleToggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };


  
  useEffect(() => {
    const toggle = document.getElementById("feature-dropdown-menu__toggle");
    const menu = document.getElementById("submenu");
  
    if (!toggle || !menu) return;
  
    function toggleMenu() {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !expanded);
      menu.hidden = expanded;
    }
  
    toggle.addEventListener("click", toggleMenu);
  
    return () => toggle.removeEventListener("click", toggleMenu);
  }, []);

  return (
    <Layout>
      {/* <head dangerouslySetInnerHTML={{
                __html: metaData && metaData,
              }} /> */}
      {metaData ? (
        <NextSeo
          title={metaData?.title}
          description={metaData?.description}
          index={metaData?.robots?.index}
          follow={metaData?.robots?.follow}
          robotsProps={metaData?.robots}
          canonical={SITE_URL}
          openGraph={{
            type: metaData?.og_type,
            locale: metaData?.og_locale,
            siteName: metaData?.og_site_name,
            url: metaData?.og_url,
            type: metaData?.og_type,
            title: metaData?.og_title,
            description: metaData?.og_description,
            images: metaData?.og_image,
          }}
          // facebook={}
          twitter={{
            handle: metaData?.twitter_description,
            site: metaData?.twitter_title,
            cardType: metaData?.twitter_card,
          }}
          //additionalMetaTags={}
          //defaultTitle={}
        />
      ) : (
        <NextSeo title="sdcera" />
      )}
      {loading ? (
        <div className="custom_loader">
          <MoonLoader color="#394d6b" speedMultiplier={0.5} />
        </div>
      ) : (
        <main role="main"  className="mb-auto" id="page_content">
          {banner?.acf?.["home-topbar-content"] ? (
            <section className="description-area red">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <div
                      className="heading-descrip"
                      dangerouslySetInnerHTML={{
                        __html: banner?.acf?.["home-topbar-content"].substring(
                          0,
                          10000
                        ),
                      }}
                    />

                 <button
                  type="button"
                  className="close-icon"
                  aria-label="Close notification"
                  onClick={() => closeBar()}
                >
                  <i className="fa fa-close" aria-hidden="true"></i>
                </button>


                  </div>
                </div>
              </div>
            </section>
          ) : (
            ""
          )}
          <div
            className="hero_slider padding-bottom-top-120"
            style={{
              backgroundImage:
                "url(" +
                (banner?.acf?.banner_image && banner?.acf?.banner_image.url) +
                ")",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-lg-4">
                  {/* <h2 className="color_white"> {banner?.acf?.banner_title} </h2> */}
                  <h1 className="hero_title color_white">
                    {banner?.acf?.banner_title}
                  </h1>

                  <p
                    dangerouslySetInnerHTML={{
                      __html: banner?.acf?.banner_description,
                    }}
                  />

         
                  <ul className="dropdown-anchor bannerMenu">

                    <li className="menu--has-submenu">
                      <button
                        id="feature-dropdown-menu__toggle"
                        className="menu__toggle"
                        aria-haspopup="true"
                        aria-expanded={isMenuOpen ? "true" : "false"}
                        aria-controls="submenu"
                        onClick={handleToggleMenu}
                        aria-label={banner?.acf?.banner_menus || "Toggle menu"}
                      >
                        {banner?.acf?.banner_menus}
                      </button>
                      

                      <button
                        type="button"
                        className="menu__icon bannerMenu_btn"
                        aria-haspopup="true"
                        aria-expanded={isMenuOpen ? "true" : "false"}
                        aria-controls="submenu"
                        onClick={handleToggleMenu}
                        aria-label={"Toggle menu"}
                      >
                        <span className="sr-only">Toggle menu</span>
                      </button>

                      {banner?.acf?.banner_menu_items?.length > 0 ? (
                        <ul
                          className="dropdown bannerMenu_sub"
                          id="submenu"
                          hidden={!isMenuOpen}
                          aria-label={banner?.acf?.banner_menus || "Menu"}
                        >
                          {banner?.acf?.banner_menu_items.map((item, index) => (
                            <li key={index}>
                              <a
                                href={item.item_link?.url}
                                target={item.item_link?.target}
                                // aria-label={item.item_name}
                                tabIndex={isMenuOpen ? 0 : -1}
                                onClick={(e) => {
                                  if (!isMenuOpen) {
                                    e.preventDefault();
                                    return;
                                  }
                                  handleMenuClose();
                                }}
                              >
                                {item.item_name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>

                  </ul>
            




                </div>
              </div>
            </div>
          </div>
          <section id="get-started" className="padding">
            <div className="container">
              <div className="section-header inline-block w-100">
                <div className="row">
                  <div className="col-xs-12 text-center">
                    <h2
                      className="desktop-only"
                      dangerouslySetInnerHTML={{
                        __html: banner?.acf?.get_started_title,
                      }}
                    />
                    <h2 className="mobile-only">
                      {" "}
                      {banner?.acf?.get_started_title.split("—")[0]}
                    </h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: banner?.acf?.get_started_sub_title,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="get-started-steps inline-block w-100 mt-30">
                <div className="row justify-content-center">
                  {banner?.acf?.get_started_content &&
                    banner?.acf?.get_started_content.length > 0 &&
                    banner?.acf?.get_started_content.map((ele, i) => {
                      return (
                        <div
                          key={i}
                          className="col-md-4 col-lg-3 col-xs-6 text-center"
                        >
                          <Link
                            href={ele?.link ? ele?.link?.url : "#"}
                            target={ele?.link?.target}
                          >
                            <a
                              onClick={() =>
                                handleRedirect(ele?.link ? ele?.link?.url : "/")
                              }
                             aria-label={ele?.title ? ele?.title.replace(/<[^>]+>/g, "") : "Get Started Content"}
                            >
                              <div className="get-started-content top40">
                                <img
                                  className="img-fluid default"
                                  src={ele?.image ? ele?.image.toString() : "#"}
                                  alt=" get started content image"
                                  aria-hidden="true"
                                />
                                <img
                                  className="img-fluid hover"
                                  aria-hidden="true"
                                  src={
                                    ele?.hover_image
                                      ? ele?.hover_image.toString()
                                      : "#"
                                  }
                                  alt="get started content image"
                                />
                                <h3
                                  dangerouslySetInnerHTML={{
                                    __html: ele?.title,
                                  }}
                                />
                              </div>
                            </a>
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </section>
          <section className="retire-section">
            <div className="container">
              <div className="row no-gutters">
                <div className="col-lg-7 mobile-only">
                  <div className="thumb">
                    <img
                      src={
                        banner?.acf?.how_much_image
                          ? banner?.acf?.how_much_image.toString()
                          : "#"
                      }
                      alt="how much section img"
                    />
                  </div>
                </div>
                <div className="col-lg-4 align-self-center">
                  <div className="retire-inner">
                    <div className="section-title m-0">
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: banner?.acf?.how_much_title,
                        }}
                      />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: banner?.acf?.how_much_content,
                        }}
                      />
                      <Link
                        passHref
                        href={
                          banner?.acf?.how_much_button_link
                            ? banner?.acf?.how_much_button_link
                            : "#"
                        }
                        className="Check-it-out"
                      >
                        <a
                          onClick={() =>
                            handleRedirect(
                              banner?.acf?.how_much_button_link
                                ? banner?.acf?.how_much_button_link
                                : "/"
                            )
                          }
                          // aria-label={
                          //   banner?.acf?.how_much_button || "Nearing Retirement"
                          // }
                          className="Check-it-out"
                        >
                          {banner && banner.acf && banner.acf.how_much_button
                            ? banner.acf.how_much_button
                            : "#"}
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 desktop-only">
                  <div className="thumb">
                    <img
                      src={
                        banner?.acf?.how_much_image
                          ? banner?.acf?.how_much_image.toString()
                          : "#"
                      }
                      style={{ maxWidth: "1920px" }}
                      alt="how much section img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="latest-news" className="bg_light padding">
            <div className="container">
              <div className="section-header inline-block w-100">
                <div className="row">
                  <div className="col-xs-12 text-center mb-5">
                    <h2 className="desktop-only">
                      {banner?.acf?.stay_informed_title}
                    </h2>
                    <h2 className="mobile-only">
                      {banner?.acf?.stay_informed_title.split("-")[1]}
                    </h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: banner?.acf?.stay_informed_content,
                      }}
                    />
                  </div>
                </div>
              </div>{" "}
              <div className="latest_news desktop-only">
                <div className="row top40 about_slider">
                  <div id="about-slider" className="slide-carousel top30">
                    <div className="slide-wrapper-outer" ref={targetRef}>
                      <div
                        className="slide-wrapper"
                        style={{
                          left: "0px",
                          display: "inline-block",
                          transition: "all 800ms ease 0s",
                          transform:
                            "translate3d(" + translateVal + "px, 0px, 0px)",
                          width: "" + slideWrapperWidth + "px",
                        }}
                      >
                        {postsData &&
                          postsData.length > 0 &&
                          postsData.map((post, index) => {
                            return (
                              <div
                                key={index}
                                className="slide-item"
                                ref={myRef}
                                style={{ width: "" + slideItemWidth + "px" }}
                              >
                                <div className="item">
                                  <div className="news_item  content-right-md">
                                    {/* {console.log("post", post)} */}
                                    <div
                                      className={
                                        post?.featured_media
                                          ? "image"
                                          : "image no-image"
                                      }
                                    >
                                      {post?.featured_media && (
                                        <img
                                          src={
                                            post?.featured_media
                                              ? getFitSizeimage(
                                                  post?.featured_img,
                                                  post?.featured_image_sizes
                                                    ?.sizes?.medium_large?.file
                                                ).toString()
                                              : "#"
                                          }
                                          alt="listin"
                                          className="img-fluid"
                                        />
                                      )}
                                    </div>
                                    <div className="news_content">
                                      <div className="news_text">
                                        <p>
                                          {post?.categories.length > 0 &&
                                            post?.categories.map(
                                              (cat, index) => {
                                                if (index == 0) {
                                                  return (
                                                    <span key={index}>
                                                      {getCatnameById(cat)}
                                                    </span>
                                                  );
                                                } else {
                                                  return (
                                                    <span key={index}>
                                                      , {getCatnameById(cat)}
                                                    </span>
                                                  );
                                                }
                                              }
                                            )}{" "}
                                          <span className="bullet-circle">
                                            •
                                          </span>{" "}
                                          {post?.date
                                            ? dayjs(post?.date).format(
                                                "MMMM DD, YYYY"
                                              )
                                            : ""}{" "}
                                        </p>

                                        <h3>
                                          <Link
                                            passHref
                                            href={post.slug ? post.slug : "#"}
                                          >
                                            <a
                                              onClick={() =>
                                                handleRedirect(
                                                  post.slug ? post.slug : "/"
                                                )
                                              }
                                              // aria-label={
                                              //   post.title ||
                                              //   "View post details"
                                              // }
                                            >
                                              {post.title ? post.title : "#"}
                                            </a>
                                          </Link>
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div className="slide-controls clickable">
                      <div
                        className="slide-paginations"
                        dangerouslySetInnerHTML={{
                          __html:
                            postsData &&
                            postsData.length > 0 &&
                            getPaginations(postsData.length),
                        }}
                      ></div>
                      <div className="slide-buttons">
                        <div
                          className="slide-prev"
                          onClick={() => changeSlide("prev")}
                        >
                          <i className="fa fa-angle-left" aria-hidden="true"></i>
                        </div>
                        <div
                          className="slide-next"
                          onClick={() => changeSlide("next")}
                        >
                          <i className="fa fa-angle-right" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="latest_news mobile-only">
                <div className="row">
                  {postsData &&
                    postsData.length > 0 &&
                    postsData.map((post, index) => {
                      return (
                        <div key={index} className="col-12 col-md-4">
                          <div className="news_item bottom40">
                            <div className="news_content">
                              <div className="news_text">
                                <p>
                                  {post?.categories.length > 0 &&
                                    post?.categories.map((cat, ind) => {
                                      if (ind == 0) {
                                        return (
                                          <span key={ind}>
                                            {getCatnameById(cat)}
                                          </span>
                                        );
                                      } else {
                                        return (
                                          <span key={ind}>
                                            , {getCatnameById(cat)}
                                          </span>
                                        );
                                      }
                                    })}
                                  <span className="bullet-circle">•</span>
                                  {post?.date
                                    ? dayjs(post?.date).format("MMMM DD, YYYY")
                                    : ""}{" "}
                                </p>
                                <h3>
                                  <Link
                                    passHref
                                    href={post.slug ? post.slug : "#"}
                                  >
                                    <a
                                      onClick={() =>
                                        handleRedirect(
                                          post.slug ? post.slug : "/"
                                        )
                                      }
                                      // aria-label={
                                      //   post.title || "View post details"
                                      // }
                                    >
                                      {post.title ? post.title : "#"}
                                    </a>
                                  </Link>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </section>

          <section id="upcoming" className="desktop-only">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 text-center mb-4">
                  <h2>{banner?.acf?.upcoming_event_title}</h2>
                </div>
              </div>
              <div className="row">
                <div id="nospace-filter" className="cbp-l-filters-alignCenter">
                  <div
                    onClick={() => {
                      getEventPosts(0);
                    }}
                    data-cat="0"
                    className={
                      currentEventCat == 0
                        ? "cbp-filter-item-active cbp-filter-item"
                        : "cbp-filter-item"
                    }
                  >
                    All
                  </div>
                  {eventCategories &&
                    eventCategories.length > 0 &&
                    eventCategories.map((cat, ind) => {
                      return (
                        <div
                          key={ind}
                          data-cat={cat.id}
                          onClick={() => {
                            getEventPosts(cat.id);
                          }}
                          className={
                            currentEventCat == cat.id
                              ? "cbp-filter-item-active cbp-filter-item"
                              : "cbp-filter-item"
                          }
                        >
                          {cat.name}
                        </div>
                      );
                    })}
                </div>
                <div
                  id="nospace"
                  className="cbp cbp-caption-active cbp-caption-pushTop cbp-ready"
                  style={{ height: "136px" }}
                >
                  <div className="cbp-wrapper-outer">
                    <div className="cbp-wrapper">
                      {eventPosts &&
                        eventPosts.length > 0 &&
                        eventPosts.map((event, ind) => {
                          return (
                            <Link
                              key={ind}
                              passHref
                              href={"/event/" + event?.slug.toString()}
                            >
                              <a
                                onClick={() =>
                                  handleRedirect(
                                    event?.slug
                                      ? "/event/" + event?.slug.toString()
                                      : "/"
                                  )
                                }
                                aria-label={event?.title ? event.title : "View event details"}
                              >
                                <div
                                  className={
                                    getEventCats(
                                      event?.eventcategory.length > 0 &&
                                        event?.eventcategory
                                    ) + " cbp-item "
                                  }
                                >
                                  <div className="event-item clearfix">
                                    <div className="event-image">
                                      <div className="post-date">
                                        <small className="month">
                                          {getCovertMonthFormat(
                                            event?.acf.event_date
                                          )}
                                        </small>
                                        <br />
                                        <span className="date">
                                          {getCovertDateFormat(
                                            event?.acf.event_date
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="event-content">
                                      <div className="event-title mb-15">
                                        <h3 className="title">
                                          {" "}
                                          {event?.title}{" "}
                                        </h3>
                                        <span className="ticket-price yellow-color">
                                          {getCovertTimeFormat(
                                            event?.acf.event_time
                                          )}{" "}
                                          PST
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </Link>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-12 text-center"
                dangerouslySetInnerHTML={{
                  __html: banner?.acf?.upcoming_event_extra_content,
                }}
              ></div>
              <div className="col-lg-12 text-center">
                <ul className="upcoming-events">
                  <li>
                    <Link
                      href={
                        banner?.acf?.most_recent_agenda_link
                          ? banner?.acf?.most_recent_agenda_link
                          : "#"
                      }
                    >
                      <a
                        onClick={() =>
                          handleRedirect(
                            banner?.acf?.most_recent_agenda_link
                              ? banner?.acf?.most_recent_agenda_link
                              : "/"
                          )
                        }
                        aria-label={"Most Recent Agenda"}
                      >
                        <i className="fa fa-file" aria-hidden="true"></i> Most Recent Agenda
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/calendar/events">
                      <a
                        onClick={() => handleRedirect("/calendar/events")}
                        aria-label={"Full Event Calendar"}
                      >
                        <i className="fa fa-calendar" aria-hidden="true"></i> Full Event Calendar
                      </a>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <section id="upcoming-mobile" className="mobile-only padding">
            <div className="container">
              <div className="row">
                <div className="col-sm-1 col-md-2"></div>
                <div className="col-md-12 text-center">
                  <h2>{banner?.acf?.upcoming_event_title}</h2>
                </div>
                <div className="col-sm-1 col-md-2"></div>
              </div>
              <div className="row mb-4">
                <div className="col-lg-12 text-center">
                  <ul className="upcoming-events">
                    <li>
                      <Link
                        href={
                          banner?.acf?.most_recent_agenda_link
                            ? banner?.acf?.most_recent_agenda_link
                            : "#"
                        }
                      >
                        <a
                          onClick={() =>
                            handleRedirect(
                              banner?.acf?.most_recent_agenda_link
                                ? banner?.acf?.most_recent_agenda_link
                                : "/"
                            )
                          }
                          aria-label={"Most Recent Agenda"}
                        >
                          <i className="fa fa-file" aria-hidden="true"></i> Most Recent Agenda
                        </a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/calendar/events">
                        <a
                          onClick={() => handleRedirect("/calendar/events")}
                          aria-label={"Full Event Calendar"}
                        >
                          <i className="fa fa-calendar" aria-hidden="true"></i> Full Event Calendar
                        </a>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row">
                {eventPosts &&
                  eventPosts.length > 0 &&
                  eventPosts.map((event, ind) => {
                    return (
                      <Link
                        key={ind}
                        passHref
                        href={"event/" + event?.slug.toString()}
                      >
                        <a
                          onClick={() =>
                            handleRedirect(
                              event?.slug
                                ? "event/" + event?.slug.toString()
                                : "/"
                            )
                          }
                          aria-label={event?.title || "View event details"}
                        >
                          <div className="col-md-4">
                            <div className="event-item">
                              <div className="event-image">
                                <div className="post-date">
                                  <small className="month">
                                    {getCovertMonthFormat(
                                      event?.acf.event_date
                                    )}
                                  </small>
                                  <br />
                                  <span className="date">
                                    {getCovertDateFormat(event?.acf.event_date)}
                                  </span>
                                </div>
                              </div>
                              <div className="event-content">
                                <div className="event-title mb-15">
                                  <h3 className="title"> {event?.title}</h3>
                                  <span className="ticket-price yellow-color">
                                    {getCovertTimeFormat(event?.acf.event_time)}{" "}
                                    PST
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </Link>
                    );
                  })}
              </div>
            </div>
          </section>

          <section className="life-events">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-offset-1 col-lg-6">
                  <h2>{banner?.acf?.life_event_title}</h2>
                  <h3>{banner?.acf?.life_event_sub_title}</h3>
                  <div
                    className="events-content"
                    dangerouslySetInnerHTML={{
                      __html: banner?.acf?.life_event_content,
                    }}
                  />
                  <Link
                    href={
                      banner?.acf?.life_event_button_link
                        ? banner?.acf?.life_event_button_link
                        : "#"
                    }
                    className="desktop-only view-more-btn"
                  >
                    <a
                      onClick={() =>
                        handleRedirect(
                          banner?.acf?.life_event_button_link
                            ? banner?.acf?.life_event_button_link
                            : "/"
                        )
                      }
                      // aria-label={
                      //   banner &&
                      //   banner.acf &&
                      //   banner.acf.life_event_button_text
                      //     ? banner.acf.life_event_button_text
                      //     : "#"
                      // }
                      className="desktop-only view-more-btn"
                    >
                      {banner && banner.acf && banner.acf.life_event_button_text
                        ? banner.acf.life_event_button_text
                        : "#"}
                    </a>
                  </Link>
                </div>
                <div className="col-md-6 col-lg-5">
                  <div
                    role="region" 
                    aria-label="Life event details"
                    dangerouslySetInnerHTML={{
                      __html: banner?.acf?.life_event_extra_content,
                    }}
                  />
                  <Link
                    passHref
                    href={
                      banner?.acf?.life_event_button_link
                        ? banner?.acf?.life_event_button_link
                        : "#"
                    }
                    className="mobile-only view-more-btn"
                  >
                    <a
                      onClick={() =>
                        handleRedirect(
                          banner?.acf?.life_event_button_link
                            ? banner?.acf?.life_event_button_link
                            : "/"
                        )
                      }
                      // aria-label={
                      //   banner &&
                      //   banner.acf &&
                      //   banner.acf.life_event_button_text
                      //     ? banner.acf.life_event_button_text
                      //     : "#"
                      // }
                      className="mobile-only view-more-btn"
                    >
                      {banner && banner.acf && banner.acf.life_event_button_text
                        ? banner.acf.life_event_button_text
                        : "#"}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="life-events-img">
            <div className="container-fluid">
              <div className="row">
                <img
                  className="img-fluid"
                  src={
                    banner?.acf?.life_event_image
                      ? banner?.acf?.life_event_image.toString()
                      : "#"
                  }
                  alt="footer image"
                />
              </div>
            </div>
          </section>
        </main>
      )}
    </Layout>
  );
}

export async function getServerSideProps({ res }) {
  // const posts = await getLatestPosts(12);

  setEdgeHeader({
    res,
    cacheControl: "public, s-maxage=600, stale-while-revalidate=600",
  });

  return {
    props: {
      posts: [],
    },
  };
}